import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../../../constants/common'
import { getItemsFromIdwellApiResponse } from '../../../../../../utils/api'
import { FieldStackedLabel } from '../../../../../Field'
import {
  FormBody,
  FormFieldsContainer,
  FormFieldSelectNG,
} from '../../../../../Form'
import { FormikField } from '../../../../../Formik'
import {
  getMockViewingApplicants,
  RentalPortalViewingApplicantsSelect,
} from '../../../../../RentalPortalViewing'
import { useInitiallyOpenSelect } from '../../../../../Select'
import { VIEWING_APPLICANTS_FIELD_NAME } from '../../RentalPortalViewingProfileWidgetApplicants.constants'
import {
  getViewingApplicantsFieldLabelKey,
  toViewingApplicantsSelectItems,
} from '../../RentalPortalViewingProfileWidgetApplicants.utils'

import * as styles from './ViewingApplicantsFormFields.module.css'

function ViewingApplicantsFormFields({
  listingId,
  primaryApplicantId,
  onCancel,
}) {
  const { t } = useTranslation()

  const { dirty, isSubmitting } = useFormikContext()

  const selectStatesRef = useInitiallyOpenSelect()

  function handleCancel() {
    onCancel({ dirty })
  }

  return (
    <FormBody
      actionsProps={{
        ButtonAdd: false,
        ButtonClear: false,
        Header: false,
        UploadComponent: false,
        cancelProps: {
          onClick: handleCancel,
        },
        isSubmitting,
        submitProps: {
          isLoading: isSubmitting,
          title: 'Modal.SaveBtnKey',
        },
      }}
    >
      <FormFieldsContainer className={styles.fields}>
        <FormikField
          multi
          Component={FormFieldSelectNG}
          Field={FieldStackedLabel}
          Select={RentalPortalViewingApplicantsSelect}
          apiParams={{
            exclude_applicant_id: primaryApplicantId,
            listing_id: listingId,
          }}
          controlProps={{
            contentProps: {
              inputProps: {
                placeholder: t(
                  'RentalPortal.ViewingFormApplicantPlaceholderKey'
                ),
              },
            },
          }}
          emptyValue={EMPTY_LIST}
          fieldComponentProps={{
            label: t(getViewingApplicantsFieldLabelKey(primaryApplicantId)),
          }}
          getData={getMockViewingApplicants}
          getDataItems={getItemsFromIdwellApiResponse}
          name={VIEWING_APPLICANTS_FIELD_NAME}
          selectStatesRef={selectStatesRef}
          toPreparedItems={toViewingApplicantsSelectItems}
        />
      </FormFieldsContainer>
    </FormBody>
  )
}

export default ViewingApplicantsFormFields
